import { ImageModel } from "../../data/entities";
import { ImageRepo, ImageODataRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class ImageService extends BaseEntityService<ImageModel, ImageRepo, ImageODataRepo> {
  constructor(){
    super(new ImageRepo(), new ImageODataRepo());
  }
  
}

export default ImageService;
